<template>
  <div></div>
</template>
<script>
import router from "@/router";
export default {
  name: "login",
  data: {},
  created() {
    // this.$store.dispatch("common/loginAction").then((res) => {
    //   if (res.code == 0) {
    //     this.$store.dispatch("common/fetchUserInfoAction").then((res) => {
    //       if (res.code == 0) {
    //         router.push("/gsyy");
    //       }
    //     });
    //   }
    // });
    // return {};
  },
};
</script>
